import { render, staticRenderFns } from "./HomeIndexCarousel.vue?vue&type=template&id=27f70434&scoped=true&"
import script from "./HomeIndexCarousel.vue?vue&type=script&lang=js&"
export * from "./HomeIndexCarousel.vue?vue&type=script&lang=js&"
import style0 from "./HomeIndexCarousel.vue?vue&type=style&index=0&id=27f70434&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f70434",
  null
  
)

export default component.exports